(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[120],{

/***/ 95759:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(72917);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _storyblok_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41481);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72988);



const Slug = (param)=>{
    let { sbData , ...rest } = param;
    if (sbData) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(SbPage, {
        sbData: sbData,
        ...rest
    });
    return null;
};
const SbPage = (param)=>{
    let { sbData  } = param;
    const storyData = (0,_storyblok_react__WEBPACK_IMPORTED_MODULE_0__/* .useStoryblokState */ .f0)(sbData.story);
    (0,_hooks__WEBPACK_IMPORTED_MODULE_1__/* .usePaddleInit */ .bT)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_storyblok_react__WEBPACK_IMPORTED_MODULE_0__/* .StoryblokComponent */ .Xj, {
        blok: storyData === null || storyData === void 0 ? void 0 : storyData.content
    });
};
Slug.displayName = "SB Page";
Slug.category = "";
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Slug);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(95759); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);